var render = function render(){var _vm=this,_c=_vm._self._c;return _c('perfect-scrollbar',{ref:"timePicker",staticClass:"app-time-picker px-3"},_vm._l((_vm.times),function(time){return _c('div',{key:time.display,staticClass:"px-2 py-2",on:{"click":function($event){return _vm.onClick(time)}}},[_vm._v(" "+_vm._s(time.display)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }